var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyGridfront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 1008,
    viewBox: "0 0 366 1008",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 526H40L44.5 534.5L45 537V545.5L44 557L41 571L38 574H35.5L31 567L29 561L27 553L26 548H24L23 550V561L29 574L42 591V594L40 596H29L26 595L19 591C17.0963 589.389 13.5973 586.44 13.0472 586.019C13.049 586.039 13.034 586.034 13 586C12.9514 585.951 12.9712 585.961 13.0472 586.019C13.0279 585.806 11.0675 582.677 10 581L5 569.5L2 558.5L1 552L0 544V526Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184 417H264.136L270 478H184V417Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9266 416.999L184 416.999L184 478L94.0001 478L98.9266 416.999Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184 354H264V417H184V354Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99 354H184V417H99V354Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301 420H359L362 479H349H346H320L301 420Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288 357H351L359 420H301L288 357Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75 356H14L5 419H62L75 356Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130 46C130 34.0653 137.061 17.9392 147 9.50005C156.939 1.06091 173 -3.19123e-10 184 0V46H130Z",
    fill: "#D9D9D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M235 46C233.5 38.5 231.189 24.9391 222 16.5C212.811 8.06087 198 -3.52412e-06 184 0V46H235Z",
    fill: "#D9D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130 46H184V81H130V46Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 46H235V81H184V46Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327 238.021C327 230.473 324.391 213.23 321.955 206.257C319.518 199.284 320.901 199.828 316.399 194.491C311.897 189.154 300.937 182.294 295.054 179.406C289.172 176.517 282.367 175 276 175V238.021H327Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184 135L217 127L227.5 154.868L245.5 170.647L277 175H184V135Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204 815H213H277L268 891H216L204 815Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86 815H160.5L148 891L95 891.5L86 815Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216 891H268L269 960H257H247H239H231.5H221L216 891Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95 891H148L143 958H98H95V891Z",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 958H143L144.5 963.5L145.245 970V990.176L143.5 994.923L142 997.56L140.5 1000.73L138 1002.84L123.5 1006H98.5L91 1004.42L85.5 1001.25L83.5 1000L82 998L81 994.5L80 988.632L81 982.5L86.5 970.5L92 963.275L95 958H98.5Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241 960H221L219 968L218 974.5V981V987.5L221 994L223 998L225 1000L227 1002L228 1003.13L238 1008H250H261.5L269 1006H270.5L273 1005L275.379 1004H276.5H278.5L283 1003.13L284 1002L286 1000V996.5V993L284 987.5L282.5 984.5L281 981L279 976.5L276.968 973.5L274.573 969L272 965.816L271 962L269 960H254.5H241Z",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276 238H327L337 292H276L276 238Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276 292H337L351 357H288L276 292Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184 81H235L217 127L184 135V81Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146 127L184 135V175H85L124 164.5L141 146.5L146 127Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130 81H184V135L146 127L130 81Z",
    fill: "#D9D9D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5 419H62L45 480H1L5 419Z",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999994 480H45L35 500V512L40 526H3.8147e-06L0.999994 480Z",
    fill: "#D9D9D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M320 479H362L366 522H325L326.5 507.5L325 485.5L320 479Z",
    fill: "#D9D9D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M366 522H325L324 525.5L323 536.5C323 536.9 322.5 541 322.5 543C322.167 543.333 322.3 544.6 321.5 547C320.7 549.4 321.5 552.5 320.5 553.5L322 558L323 562L325 566L328 568H330L334 563L336 557L337 553L338 549L339 543L340 542L342 543L343 545V554.5L341 560L336 571L330 581L325.5 587L325 589V596H334L341 594L346 591L350 588L355 582L358 577L360.5 573L362 567L364 558L365 552L366 543V522Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87 175H184V238H87V175Z",
    fill: "#D9D9D9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184 175H276V238H184V175Z",
    fill: "#D9D9D9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87 238H184V292H87V238Z",
    fill: "#D9D9D9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M184 238H276V292H184V238Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35 238C35 231 35.937 223.083 38.5 215.5C41.063 207.917 43.8431 202 50.9375 193.306C55.6733 187.502 61.2955 182.898 67.4831 179.758C73.6707 176.617 80.3026 175 87 175V207V238H35Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 238H79.2028H87V292H29L34.8 238Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89 292H184V354H99.3158L89 292Z",
    fill: "#D9D9D9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29 292H89L75 356H14L29 292Z",
    fill: "#D9D9D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184 292H276L264 355H184V292Z",
    fill: "#D9D9D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M204 815L200 753.5H276.5L277 815H204Z",
    fill: "#D9D9D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200 753.5L195 689.5H276L276.5 753.5H200Z",
    fill: "#D9D9D9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M195 689.5L186.5 618.5H279.5L276 689.5H195Z",
    fill: "#D9D9D9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.5 618.5L184 549H277L279.5 618.5H186.5Z",
    fill: "#D9D9D9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86 815V753H163L160.5 815H86Z",
    fill: "#D9D9D9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169 688H85L86 753H163L169 688Z",
    fill: "#D9D9D9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M176 616H84L85 688H169L176 616Z",
    fill: "#D9D9D9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M184 549H86L84 616H176L184 549Z",
    fill: "#D9D9D9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 549L94 478H184V549H86.5Z",
    fill: "#D9D9D9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M270 478H184V549H277L270 478Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyGridfront);
export default __webpack_public_path__ + "static/media/body-grid front.34929ce93234c218f6762f97d0a76282.svg";
export { ForwardRef as ReactComponent };